import request from "@/utils/request";

// 分页查询用户
export const  pageUser =(data) =>{
    return request({
        url: "/businessservice/user/page",
        method:"post",
        data: data
    })
}

// 添加平台管理员
export const  adminAdd =(query) =>{
    return request({
        url: "/businessservice/admin/add",
        method:"get",
        params: query
    })
}
// 取消平台管理员
export const  adminCancel =(query) =>{
    return request({
        url: "/businessservice/admin/cancel",
        method:"get",
        params: query
    })
}

// 删除用户
export const  userDelete =(query) =>{
    return request({
        url: "/businessservice/user/delete",
        method:"get",
        params: query
    })
}

// 查询用户列表
export const  userList =(query) =>{
    return request({
        url: "/businessservice/user/list",
        method:"get",
        params: query
    })
}

// 注册用户
export const  registerUser =(data) =>{
    return request({
        url: "/businessservice/user/register",
        method:"post",
        data: data
    })
}

// 获取用户信息
export const  userInfo =(query) =>{
    return request({
        url: "/businessservice/user/info",
        method:"get",
        params: query
    })
}
// 更新用户信息
export const  userUpdate =(data) =>{
    return request({
        url: "/businessservice/user/update",
        method:"post",
        data: data
    })
}

// 点亮或点灭用户荣誉
export const  userLightHonorOrCancel =(data) =>{
    return request({
        url: "/businessservice/user/lightHonorOrCancel",
        method:"post",
        data: data
    })
}